module.exports = __webpack_public_path__ + "static/media/clue-instructions.d1c0403d.webp";